import  DietaryPreferences  from "@/lib/printess/source_menu/dietaryPreferences"

export default class MenuItem {
  static fromRaw({
    vegan = false,
    vegetarian = false,
    halal = false,
    kosher = false,
    name = "",
    price = 0,
    item_description = "",
    category = "",
    alcohol_percentage = null,
  } = {}) {
    const dietaryPreferences = new DietaryPreferences(
      vegan,
      vegetarian,
      halal,
      kosher,
    );

    return new MenuItem(
      name,
      price,
      item_description,
      category,
      dietaryPreferences,
      alcohol_percentage,
    );
  }

  constructor(
    name = "",
    price = 0,
    description = "",
    category = "",
    dietary_preferences = null,
    alcohol_percentage = null,
  ) {
    this.name = name;
    this.price = price;
    this.description = description;
    this.category = category;
    this.dietaryPreferences = dietary_preferences || new DietaryPreferences();
    this.alcohol_percentage = alcohol_percentage;
  }
}
